


const state = {
    showLoginCom:true,// 显示登录模块,用与登录和注册的互相切换
    findPasswordModelOpen:false,// 找回密码模态框是否打开
}

const mutations = {
    showLoginComCtr: (state, payload) => {
        state.showLoginCom = payload
},

    findPasswordModelOpenCtr: (state, payload) => {
        state.findPasswordModelOpen = payload
    },

}
const actions = {



}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    mutations,
    actions,
    modules
}

